@if (credits$$(); as c) {
    <section class="panel__section">
        <h3 class="panel__title">{{ _text.overview }}</h3>
        @if (state$$() === 'suspended') {
            <p class="panel__notice">
                {{ _text.suspended }}
                @if (c[domainCreditsDto.cleanupFrom]) {
                    {{ _text.cleanupFrom }} {{ c[domainCreditsDto.cleanupFrom] | appDate }}.
                }
            </p>
        } @else if (c[domainCreditsDto.archived]) {
            <p class="panel__notice">{{ _text.archived }}</p>
        } @else if (state$$() === 'readOnly') {
            <p class="panel__notice">{{ _text.readOnly }}</p>
        }
        @if (c[domainCreditsDto.billingGraceUntil]) {
            <p class="panel__notice">{{ _text.graceUntil }} {{ c[domainCreditsDto.billingGraceUntil] | appDate }}.</p>
        }
        @if (!c[domainCreditsDto.billingStartPeriod]) {
            <p class="panel__info">{{ _text.notStarted }}</p>
        }

        <dl class="panel__figures">
            <dt>{{ _text.balance }}</dt>
            <dd [class.panel__negative]="(c[domainCreditsDto.creditBalance] ?? 0) < 0">{{ number_format(c[domainCreditsDto.creditBalance]) }}</dd>
            @if (c[domainCreditsDto.creditLimit]) {
                <dt>{{ _text.limit }}</dt>
                <dd>{{ number_format(c[domainCreditsDto.creditLimit]) }}</dd>
            }
            <dt>{{ _text.spent }}</dt>
            <dd>{{ number_format(c[domainCreditsDto.spent]) }}</dd>
            <dt>{{ _text.expected }} ({{ chargeLabel$$() }})</dt>
            <dd>{{ number_format(c[domainCreditsDto.expectedCharge]) }}</dd>
            <dt>{{ _text.required }}</dt>
            <dd>{{ number_format(c[domainCreditsDto.required]) }}</dd>
            <dt>{{ _text.available }}</dt>
            <dd [class.panel__negative]="(c[domainCreditsDto.available] ?? 0) < 0">{{ number_format(c[domainCreditsDto.available]) }}</dd>
        </dl>
        <p class="panel__info">{{ _text.availableInfo }}</p>
    </section>

    @if (canPurchase$$()) {
        <section class="panel__section">
            <h3 class="panel__title">{{ _text.purchase }}</h3>
            <p class="panel__info">{{ paymentOnline$$() ? _text.purchaseInfoOnline : _text.purchaseInfo }}</p>
            <div class="panel__grid">
                <app-input-control
                    [control]="control_bundles"
                    [label]="_text.bundles + ' (' + _text.bundleOf + ' ' + number_format(bundle$$()) + ' ' + _text.credits + ')'"
                    [type]="'number'"
                    [hint]="control_bundles.invalid ? _text.bundlesInvalid : ''" />
                @if (!paymentOnline$$()) {
                    <app-input-control [control]="control_note" [label]="_text.note" />
                }
            </div>
            @if (purchaseTotal$$() != null) {
                <p>{{ number_format(purchaseCredits$$()) }} {{ _text.credits }} · {{ _text.total }}: {{ money_format(purchaseTotal$$()) }}</p>
            }
            @if (requestSent$$() != null) {
                <p class="panel__info">{{ _text.requestSent }} {{ number_format(requestSent$$()) }} credits.</p>
            }
            <app-buttons-row [align]="buttonsRowAlign.end">
                <app-button-action (btnClick)="emit_purchase()" [disabled]="purchaseDisabled$$()" [tooltip]="paymentOnline$$() ? _text.pay : _text.request">
                    <app-icon name="send-plane" />
                </app-button-action>
            </app-buttons-row>
        </section>
    }

    <section class="panel__section">
        <h3 class="panel__title">{{ _text.billingDetails }}</h3>
        <p class="panel__info">{{ _text.billingDetailsInfo }}</p>
        <p class="panel__address">
            {{ c[domainCreditsDto.name] }}
            @if (c[domainCreditsDto.billingAddress]) {
                <br>{{ c[domainCreditsDto.billingAddress] }}
            }
        </p>
        <div class="panel__grid">
            <app-input-control [control]="control_vatNumber" [label]="_text.vatNumber" />
            <app-input-control
                [control]="control_billingEmail"
                [label]="_text.billingEmail"
                [placeholder]="_text.billingEmailPlaceholder + ' (' + c[domainCreditsDto.ownerEmail] + ')'"
                [hint]="control_billingEmail.invalid ? _text.billingEmailInvalid : ''" />
        </div>
        @if (canPurchase$$()) {
            <app-buttons-row [align]="buttonsRowAlign.end">
                <app-button-action (btnClick)="emit_detailsSave()" [disabled]="detailsDisabled$$()" [tooltip]="_text.save">
                    <app-icon name="save" />
                </app-button-action>
            </app-buttons-row>
        }
    </section>

    @if (isOwner$$()) {
        <section class="panel__section">
            <h3 class="panel__title">{{ _text.archive }}</h3>
            <p class="panel__info">{{ _text.archiveInfo }}</p>
            <app-buttons-row [align]="buttonsRowAlign.end">
                @if (c[domainCreditsDto.archived]) {
                    <app-button-action (btnClick)="emit_archive(false)" [disabled]="saving$$()" [tooltip]="_text.archiveClear">
                        <app-icon name="unlock" />
                    </app-button-action>
                } @else {
                    <app-button-action (btnClick)="emit_archive(true)" [disabled]="saving$$()" [tooltip]="_text.archiveSet">
                        <app-icon name="lock" />
                    </app-button-action>
                }
            </app-buttons-row>
        </section>
    }

    <section class="panel__section">
        <h3 class="panel__title">{{ _text.ledger }}</h3>
        @if (transactions$$(); as transactions) {
            @if (transactions.length === 0) {
                <p class="panel__info">{{ _text.empty }}</p>
            } @else {
                <div class="panel__ledger">
                    <span class="panel__head">{{ _text.date }}</span>
                    <span class="panel__head">{{ _text.type }}</span>
                    <span class="panel__head panel__num">{{ _text.amount }}</span>
                    <span class="panel__head">{{ _text.invoice }}</span>
                    @for (t of transactions; track t[creditTransactionDto.guid]) {
                        <span>{{ t[creditTransactionDto.createdOn] | appDate }}</span>
                        <span>
                            {{ type_label(t[creditTransactionDto.type]) }}
                            @if (t[creditTransactionDto.period]) {
                                <small>{{ period_label(t[creditTransactionDto.period]) }}</small>
                            }
                            @if (t[creditTransactionDto.note]) {
                                <small>{{ t[creditTransactionDto.note] }}</small>
                            }
                        </span>
                        <span class="panel__num" [class.panel__negative]="(t[creditTransactionDto.credits] ?? 0) < 0">{{ number_format(t[creditTransactionDto.credits]) }}</span>
                        <span>
                            @if (t[creditTransactionDto.invoiceNr] != null) {
                                <button type="button" class="panel__link" [title]="_text.invoicePrint" (click)="emit_invoicePrint(t)">
                                    {{ t[creditTransactionDto.invoiceNr] }}
                                </button>
                                · {{ money_format(t[creditTransactionDto.invoiceTotal]) }}
                            }
                        </span>
                    }
                </div>
            }
        } @else {
            <p class="panel__info">{{ _text.loading }}</p>
        }
    </section>

    <app-billing-dry-run [dauGuid]="input_dauGuid$$()" />
} @else if (loadFailed$$()) {
    <p class="panel__info">{{ _text.loadFailed }}</p>
} @else {
    <p class="panel__info">{{ _text.loading }}</p>
}
